import { useAppContext } from '@/Main';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import type { ReactNode } from 'react';
import { Card, Form } from 'react-bootstrap';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';

interface ProgressCardProps {
  tooltip?: string;
  title: ReactNode;
  range?: number;
  min?: number;
  max?: number;
}

const ProgressCard = ({ tooltip, title, range, min, max }: ProgressCardProps) => {
  const {
    config: { theme }
  } = useAppContext();

  return (
    <Card className="h-md-100">
      <FalconCardHeader
        title={
          <div>
            {title}
            {tooltip && <HelpTooltip html={tooltip} />}
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
      />

      <Card.Body className="fs--1 p-3">
        {range !== undefined && min != undefined && max != undefined ? (
          <>
            <h5 className="text-1100 fw-bold mb-2 mt-n1">
              {range}{' '}
              <span className="fs--1 fw-normal text-700"> (میانگین) </span>
            </h5>
            <div style={{ direction: 'ltr' }}>
              <Form.Range readOnly value={range} min={min} max={max} />
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <span className="fs-0 fw-bold">{min}</span>
                  <span> (min) </span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="fs-0 fw-bold">{max}</span>
                  <span> (max) </span>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="mt-4 text_chart_loading"></div>
        )}

        <style>
          {`
              .text_chart_loading{
                background:${changeBgColor(theme)}
              }
          `}
        </style>
      </Card.Body>
    </Card>
  );
};

export default ProgressCard;
